import { combineReducers } from 'redux';
import { SNACKBARS_MODULE_NAME } from './constants';
import snackbars from './reducers/snackbars';

export default combineReducers({
    [SNACKBARS_MODULE_NAME]: snackbars,
});
